module.exports = __webpack_public_path__ + "img/qa.449a46c1.svg";